import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from './components/HeroSection';
import StrengthsSection from './components/StrengthsSection';
import ServicesSection from './components/ServicesSection';
import ServiceTabsSection from './components/ServiceTabsSection';
import ContactSection from './components/ContactSection';
import InlineCtaBlock from '../../components/feature/InlineCtaBlock';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function ForOwnersPage() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const title = t('seo.forOwners.title');
    const description = t('seo.forOwners.description');

    document.title = title;

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[name="keywords"]', 'content', t('seo.forOwners.keywords'));
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', `${SITE_URL}/tokyo-airbnb-support`);
    setMeta('link[rel="canonical"]', 'href', `${SITE_URL}/tokyo-airbnb-support`);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);

    const schemaId = 'schema-for-owners';
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: title,
      description: description,
      url: `${SITE_URL}/tokyo-airbnb-support`,
      provider: {
        '@type': 'LocalBusiness',
        name: 'Magome Kominka',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Ota City',
          addressRegion: 'Tokyo',
          addressCountry: 'JP',
        },
      },
      areaServed: { '@type': 'City', name: 'Tokyo' },
      serviceType: [
        'Airbnb Management',
        'Minpaku License Application',
        'Ryokan License Application',
        'Short-term Rental Support',
      ],
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: 'JPY',
      },
    });

    return () => {
      const el = document.getElementById(schemaId);
      if (el) el.remove();
    };
  }, [i18n.language, t]);

  return (
    <div className="min-h-screen">
      <HeroSection />
      <StrengthsSection />
      <ServicesSection />
      <InlineCtaBlock />
      <ServiceTabsSection />
      <ContactSection />
    </div>
  );
}
